module.exports = __webpack_public_path__ + "img/T2B_xh_15.ef0aa017.png";